import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiRequest } from '@/lib/api-client';
import { invoiceDetailKey } from './use-invoice-detail';
import { selectableBanksKey } from './use-selectable-banks';
import type { InvoiceRow } from '../types';

export interface ReviewInvoiceInput {
  readonly field_overrides?: Record<string, string | number | null>;
  readonly issuer_bank_id?: string | null;
}

// The at-issuance review write: guarded field overrides + the bank selection.
// The server allowlist is the boundary, so no client-side field filtering is
// relied upon for correctness.
export function useReviewInvoiceMutation(invoiceId: string) {
  const qc = useQueryClient();
  return useMutation<InvoiceRow, Error, ReviewInvoiceInput>({
    mutationFn: (body) =>
      apiRequest<InvoiceRow>(`/invoices/${encodeURIComponent(invoiceId)}/review`, {
        method: 'PATCH',
        body,
      }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: invoiceDetailKey(invoiceId) });
      void qc.invalidateQueries({ queryKey: selectableBanksKey(invoiceId) });
      void qc.invalidateQueries({ queryKey: ['bl-order-detail'] });
    },
  });
}
